import React from 'react';
import cn from 'classnames';
import { STATUS_TYPES } from './constants';
import type { StatusProps } from './types';

const Status: React.FC<StatusProps> = ({ type = STATUS_TYPES.GRAY, children, className }) => (
  <div className={cn('status-default', type, className)}>{children}</div>
);

export default Status;
